import { useMemo } from 'react'

import {
  useInitiateTerminalSaleMutation,
  usePaymentTerminalsQuery,
} from './graphql/generated/types'

export function usePaymentTerminals() {
  const { data, loading, error } = usePaymentTerminalsQuery({
    pollInterval: 30000, // Poll every 30 seconds
  })

  const paymentTerminalOptions = useMemo(
    () =>
      data?.paymentTerminals.map((terminal) => ({
        value: terminal.externalDeviceId,
        label:
          terminal.state.name === 'Available'
            ? terminal.displayName
            : `${terminal.displayName} (${terminal.state.name})`,
        selectable: terminal.state.selectable,
      })) || [],
    [data?.paymentTerminals],
  )

  return {
    paymentTerminals: data?.paymentTerminals || [],
    paymentTerminalOptions,
    loading,
    error,
  }
}

export function useInitiateTerminalSale() {
  const [initiateTerminalSaleMutation, { data, loading, error }] =
    useInitiateTerminalSaleMutation()

  return {
    initiateTerminalSaleMutation,
    data: data?.initiateTerminalSale,
    loading,
    error,
  }
}
